export const loginMenuLinks: Record<'us' | 'de' | 'at' | 'hu' | 'pl' | 'ch', {
  section1Heading: string;
  section2Heading: string;
  section1Data: { linkName: string; url: string, onNewTab: boolean }[],
  section2Data: { linkName: string; url: string, onNewTab: boolean }[]
}> = {
  "de": {
    "section1Heading": "Logins für Dun & Bradstreet Produkte",
    "section1Data": [
      {
        linkName: "D&B Finance Analytics",
        url: "https://sso.dnb.com/?_gl=1*z9m82z*_gcl_au*Mzg4NDcyMzA2LjE3NDc4MDUzMjk.",
        onNewTab: true,
      },
      {
        linkName: "D&B Hoovers",
        url: "https://sso.dnb.com/?_gl=1*e4ww7g*_gcl_au*Mzg4NDcyMzA2LjE3NDc4MDUzMjk.",
        onNewTab: true,
      },
      {
        linkName: "D&B Onboard",
        url: "https://sso.dnb.com/?_gl=1*e4ww7g*_gcl_au*Mzg4NDcyMzA2LjE3NDc4MDUzMjk.",
        onNewTab: true,
      },
      {
        linkName: "Firmendatenbank",
        url: "https://www.bisnode-firmendatenbank.de/",
        onNewTab: true,
      },
      {
        linkName: "Payment Performance Insights",
        url: "https://sso.dnb.com/?_gl=1*1h4lypa*_gcl_au*Mzg4NDcyMzA2LjE3NDc4MDUzMjk.",
        onNewTab: true,
      },
      {
        linkName: "Upik",
        url: "/de-de/upik.html",
        onNewTab: false,
      },
      {
        linkName: "Country Risk Services",
        url: "https://dbia.dnb.com/Account/Login?ReturnUrl=%2f",
        onNewTab: true,
      },
      {
        linkName: "D&B Insights",
        url: "https://insights.dnbgermany.de/insights/login",
        onNewTab: true,
      },
      {
        linkName: "Data Integration Toolkit",
        url: "https://toolkit-api.dnb.com/locked/login.asp?Lang=EN&msg=S&pg=locked/find.asp?stat_link=null&i&_gl=1*jeqjof*_gcl_au*Mzg4NDcyMzA2LjE3NDc4MDUzMjk.",
        onNewTab: true,
      }
    ],
    "section2Heading": "",
    "section2Data": [],
  },
  "ch": {
    "section1Heading": "Dun & Bradstreet-Lösungen",
    "section1Data": [
      {
        linkName: "D&B Finance Analytics",
        url: "https://sso.dnb.com/?_gl=1*103srd0*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk",
        onNewTab: true,
      },
      {
        linkName: "D&B Data Manager",
        url: "http://dnbdatamanager.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Risk Analytics",
        url: "https://riskanalytics.dnb.com/en-US/login?_gl=1*15719k8*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk",
        onNewTab: true,
      },
      {
        linkName: "D&B Data Integration Toolkit",
        url: "https://toolkit-api.dnb.com/locked/login.asp?Lang=EN&msg=S&pg=locked/find.asp?stat_link=010000&_gl=1*15719k8*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk.",
        onNewTab: true,
      },
      {
        linkName: "D&B Global Reference Solution",
        url: "https://solutions.dnb.com/grs/jsp/EN-GB/GRSFrameLogon.jsp?news_country=1051&_gl=1*15719k8*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk",
        onNewTab: true,
      },
      {
        linkName: "D&B Hoovers",
        url: "https://sso.dnb.com/?_gl=1*15719k8*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk",
        onNewTab: true,
      },
      {
        linkName: "D&B Onboard",
        url: "https://sso.dnb.com/?_gl=1*15719k8*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk",
        onNewTab: true,
      },
      {
        linkName: "D&B Portfolio Manager",
        url: "https://www.portfoliomanager.dnb.com/V7.2/ContentPages/Logon/SecureLogon.aspx?_gl=1*15719k8*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk",
        onNewTab: true,
      },
      {
        linkName: "Payment Performance Insights",
        url: "https://globaltrade.dnb.com/?_gl=1*773k96*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk",
        onNewTab: true,
      }
    ],
    "section2Heading": "Wählen Sie Ihr Produkt",
    "section2Data": [
      {
        linkName: "Credit Check (BCC)",
        url: "https://www.mybcc.ch/de/bisnode/",
        onNewTab: true,
      },
      {
        linkName: "Firmendatenbank",
        url: "https://bisnode-firmendatenbank.ch/",
        onNewTab: true,
      },
      {
        linkName: "Trade Analysis Plattform",
        url: "https://tradeanalysis.bisnode.ch/login/",
        onNewTab: true,
      },
      {
        linkName: "D&B Finance Analytics Small Businesses",
        url: "https://my.dnb.com/login?_gl=1*1k5wwc1*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk.",
        onNewTab: true,
      },
      {
        linkName: "D&B Hoovers Essentials",
        url: "https://my.dnb.com/login?_gl=1*1k5wwc1*_gcl_au*ODg5NTAxNDYzLjE3NDg4NzU0Mjk.",
        onNewTab: true,
      }
    ]
  },
  "at": {
    "section1Heading": "Wählen Sie Ihr Produkt",
    "section1Data": [
      {
        linkName: "Firmendatenbank",
        url: "https://www.firmendatenbank.bisnode.at/",
        onNewTab: true,
      },
      {
        linkName: "Widata",
        url: "https://www.widata.at/login.php",
        onNewTab: true,
      },
      {
        linkName: "D&B Finance Analytics",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Hoovers",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Onboard",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Portfolio Manager",
        url: "https://www.portfoliomanager.dnb.com/App/ContentPages/Logon/SecureLogon.aspx",
        onNewTab: true,
      },
      {
        linkName: "Global Reference Solution (GRS)",
        url: "https://solutions.dnb.com/grs/jsp/EN-GB/GRSFrameLogon.jsp?news_country=869",
        onNewTab: true,
      },
      {
        linkName: "D&B DBAI",
        url: "https://online.bisnode.at/",
        onNewTab: true,
      },
    ],
    "section2Heading": "",
    "section2Data": [],
  },
  "hu": {
    "section1Heading": "",
    "section1Data": [],
    "section2Heading": "",
    "section2Data": [],
  },
  "pl": {
    "section1Heading": "",
    "section1Data": [],
    "section2Heading": "",
    "section2Data": [],
  },
  "us": {
    "section1Heading": "D&B Products",
    "section1Data": [
      {
        linkName: "Country Insight Services",
        url: "http://www.dnbcountryrisk.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Finance Analytics Credit Intelligence",
        url: "https://financeanalytics.dnb.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Onboard",
        url: "https://onboard.dnb.com/onboard/",
        onNewTab: false,
      },
      {
        linkName: "Analytics Studio",
        url: "https://sso.dnb.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Rev.Up ABX",
        url: "https://app.lattice-engines.com/login/form",
        onNewTab: false,
      },
      {
        linkName: "D&B Hoovers",
        url: "https://app.dnbhoovers.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Connect",
        url: "https://connect.dnb.com/",
        onNewTab: false,
      },
      {
        linkName: "Global Reference Solution",
        url: "https://solutions.dnb.com/grs/",
        onNewTab: false,
      },
      {
        linkName: "D&B Risk Analytics - Compliance Intelligence",
        url: "https://riskanalytics.dnb.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Risk Analytics - Supplier Intelligence",
        url: "https://riskanalytics.dnb.com/",
        onNewTab: false,
      }
    ],
    "section2Heading": "My Company Info",
    "section2Data": [
      {
        linkName: "View, Manage, Update information",
        url: "https://www.dnb.com/duns-number/view-update-company-credit-file.html",
        onNewTab: false,
      },
      {
        linkName: "myD&B",
        url: "https://my.dnb.com/login",
        onNewTab: false,
      },
    ]
  },
}
